import { useTranslation } from 'react-i18next';
import { formatCurrency } from '@monorepo/client-common';
import { Stack, Typography, useTheme } from '@monorepo/nova-ui';
import { useCalculateTotalAvailableCredit } from '../../hooks/use-calculate-total-available-credit';

const BalanceTotalAvailable = ({
  userId,
}: {
  userId?: string;
} = {}) => {
  const { totalAvailable } = useCalculateTotalAvailableCredit(userId);
  const { t, i18n } = useTranslation('hubCommon');
  const theme = useTheme();

  return (
    <Stack direction="row" alignItems="center" sx={{ marginTop: 4 }}>
      <Typography
        variant="body1"
        sx={{ marginRight: 1, fontSize: theme.typography.pxToRem(18) }}
      >
        {t('totalAvailable')}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontWeight: 600,
          fontSize: theme.typography.pxToRem(18),
        }}
      >
        {formatCurrency(totalAvailable, {
          currency: 'USD',
          decimalPlaces: 2,
          locale: i18n.language,
        })}
      </Typography>
    </Stack>
  );
};

export default BalanceTotalAvailable;
